import { type ServiceMethod } from '@/application/interfaces/service';

export type CelebreCard = {
  brand: string;
  isPrivateLabel: boolean;
  privateLabelCategory: string;
};

export type CreditCard = {
  id: string;
  numberSuffix: string;
  validUntil: string;
  brand: string;
  name: string;
  celebreCard?: CelebreCard;
};

export type Response = {
  data: CreditCard[];
};

const getCreditCards: ServiceMethod<Response> =
  (httpClient) => async (options) => {
    const { body: response } = await httpClient.get<Response>(
      '/api/v3/customer/credit-cards',
      options
    );

    return response;
  };

export default getCreditCards;
